
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.22.0
 * Query Engine version: 605197351a3c8bdd595af2d2a9bc3025bca48ea2
 */
Prisma.prismaVersion = {
  client: "5.22.0",
  engine: "605197351a3c8bdd595af2d2a9bc3025bca48ea2"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.BackfillsScalarFieldEnum = {
  id: 'id',
  name: 'name',
  finishedAt: 'finishedAt',
  startedAt: 'startedAt',
  logs: 'logs',
  gotException: 'gotException'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  password: 'password',
  confirmedAt: 'confirmedAt',
  isAdmin: 'isAdmin',
  readOnly: 'readOnly',
  teamId: 'teamId',
  defaultToolLibraryId: 'defaultToolLibraryId',
  defaultCutConfigId: 'defaultCutConfigId',
  uuid: 'uuid',
  superadmin: 'superadmin',
  defaultUnit: 'defaultUnit',
  minorDeviationLimit: 'minorDeviationLimit',
  majorDeviationLimit: 'majorDeviationLimit',
  stockDefaults: 'stockDefaults',
  appServerHost: 'appServerHost',
  features: 'features',
  controls: 'controls',
  zoomCursorMode: 'zoomCursorMode',
  projectListView: 'projectListView'
};

exports.Prisma.UserInviteTokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  createdAt: 'createdAt',
  userId: 'userId'
};

exports.Prisma.UserTokenScalarFieldEnum = {
  id: 'id',
  token: 'token',
  createdAt: 'createdAt',
  revokedAt: 'revokedAt',
  expiredAt: 'expiredAt',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  userId: 'userId'
};

exports.Prisma.UserPasswordResetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  redeemedAt: 'redeemedAt',
  expiredAt: 'expiredAt',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  userId: 'userId'
};

exports.Prisma.TeamScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  phoneNumber: 'phoneNumber',
  isActive: 'isActive',
  stripeCustomerId: 'stripeCustomerId',
  workOsOrganizationId: 'workOsOrganizationId'
};

exports.Prisma.SubscriptionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiredAt: 'expiredAt',
  stripeSubscriptionId: 'stripeSubscriptionId',
  teamId: 'teamId'
};

exports.Prisma.ProjectScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  ownerId: 'ownerId',
  teamId: 'teamId'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  slug: 'slug',
  color: 'color',
  teamId: 'teamId',
  sort: 'sort'
};

exports.Prisma.ProjectTagScalarFieldEnum = {
  projectId: 'projectId',
  tagId: 'tagId',
  sort: 'sort',
  createdAt: 'createdAt'
};

exports.Prisma.ProjectPartScalarFieldEnum = {
  projectId: 'projectId',
  partId: 'partId',
  sort: 'sort',
  createdAt: 'createdAt'
};

exports.Prisma.PartScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ownerId: 'ownerId',
  teamId: 'teamId',
  name: 'name',
  fileName: 'fileName',
  featuresDetected: 'featuresDetected',
  unit: 'unit',
  displayUnit: 'displayUnit',
  dimensions: 'dimensions',
  volume: 'volume',
  cuspHeight: 'cuspHeight',
  programId: 'programId',
  progress: 'progress',
  error: 'error',
  source: 'source',
  bodyId: 'bodyId'
};

exports.Prisma.BodyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  name: 'name',
  partId: 'partId',
  dimensions: 'dimensions',
  isModel: 'isModel'
};

exports.Prisma.ProgramScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  programShareKey: 'programShareKey',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  teamId: 'teamId',
  toolLibraryId: 'toolLibraryId',
  cutConfigId: 'cutConfigId',
  isPublic: 'isPublic',
  ownerId: 'ownerId',
  stock: 'stock',
  unit: 'unit',
  minorDeviationLimit: 'minorDeviationLimit',
  majorDeviationLimit: 'majorDeviationLimit',
  name: 'name',
  color: 'color',
  featuresDetected: 'featuresDetected',
  powerLimit: 'powerLimit',
  stockOffset: 'stockOffset',
  partId: 'partId',
  fileName: 'fileName',
  editingPermissions: 'editingPermissions',
  lastEditorId: 'lastEditorId',
  programCutConfigId: 'programCutConfigId',
  superadminOverrides: 'superadminOverrides',
  forDesignAdvisor: 'forDesignAdvisor',
  progress: 'progress',
  error: 'error',
  machinedSurfaceAreaPercent: 'machinedSurfaceAreaPercent',
  hasUnseenFeatures: 'hasUnseenFeatures',
  estimatePresetAssetUuid: 'estimatePresetAssetUuid',
  estimateMachiningTimeProgress: 'estimateMachiningTimeProgress',
  estimateMachiningTimeError: 'estimateMachiningTimeError',
  actionPlanProgress: 'actionPlanProgress',
  actionPlanError: 'actionPlanError',
  strategyProgress: 'strategyProgress',
  strategyError: 'strategyError',
  exportToFusionProgress: 'exportToFusionProgress',
  exportToFusionError: 'exportToFusionError',
  fasProgress: 'fasProgress',
  fasError: 'fasError',
  pointpathsProgress: 'pointpathsProgress',
  pointpathsError: 'pointpathsError',
  firstOpDirection: 'firstOpDirection',
  firstOpTForm: 'firstOpTForm',
  automaticFirstOpTForm: 'automaticFirstOpTForm'
};

exports.Prisma.OperationScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sort: 'sort',
  programId: 'programId',
  feature: 'feature',
  flipped: 'flipped',
  rotation: 'rotation',
  direction: 'direction',
  tform: 'tform',
  origin: 'origin',
  deburr: 'deburr',
  generatedAt: 'generatedAt',
  ipgGeneratedAt: 'ipgGeneratedAt',
  error: 'error',
  progress: 'progress',
  warnings: 'warnings',
  superadminOverrides: 'superadminOverrides',
  opPlanOpId: 'opPlanOpId',
  opPlanIntendedFeatures: 'opPlanIntendedFeatures',
  toolChanges: 'toolChanges'
};

exports.Prisma.CandidateDirectionScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  programId: 'programId',
  opPlanOpId: 'opPlanOpId',
  direction: 'direction',
  tform: 'tform',
  isFirst: 'isFirst',
  isUsed: 'isUsed',
  thumbnail: 'thumbnail'
};

exports.Prisma.OperationActionScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  description: 'description',
  toolpathToolId: 'toolpathToolId',
  featureIds: 'featureIds',
  presetName: 'presetName',
  feedRateIpm: 'feedRateIpm',
  doc: 'doc',
  woc: 'woc',
  mrr: 'mrr',
  cycleTime: 'cycleTime',
  removalVolume: 'removalVolume',
  surfaceSpeedFpm: 'surfaceSpeedFpm',
  spindleRpm: 'spindleRpm',
  sortBy: 'sortBy',
  actionIdInOperation: 'actionIdInOperation',
  operationId: 'operationId',
  programToolId: 'programToolId'
};

exports.Prisma.WorkholdingScalarFieldEnum = {
  id: 'id',
  type: 'type',
  jawHeight: 'jawHeight',
  offset: 'offset',
  rotation: 'rotation',
  operationId: 'operationId'
};

exports.Prisma.ToolScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  teamId: 'teamId',
  ownerId: 'ownerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  data: 'data',
  typeId: 'typeId',
  unit: 'unit',
  diameter: 'diameter',
  stickout: 'stickout',
  fluteLength: 'fluteLength',
  fluteCount: 'fluteCount',
  tipAngle: 'tipAngle',
  maximumRpm: 'maximumRpm',
  cornerRadius: 'cornerRadius',
  toolMaterialId: 'toolMaterialId',
  threadPitch: 'threadPitch',
  clockwiseRotation: 'clockwiseRotation',
  nominalDiameter: 'nominalDiameter',
  threadLength: 'threadLength',
  shankDiameter: 'shankDiameter',
  leadAngle: 'leadAngle',
  partialThreadCount: 'partialThreadCount',
  bottomDiameter: 'bottomDiameter',
  role: 'role',
  shoulderDiameter: 'shoulderDiameter',
  threadProfileAngle: 'threadProfileAngle',
  numberOfTeeth: 'numberOfTeeth',
  neckLength: 'neckLength',
  sideMill: 'sideMill',
  toolHolderBottomDiameter: 'toolHolderBottomDiameter',
  vendor: 'vendor',
  productId: 'productId',
  link: 'link',
  guid: 'guid'
};

exports.Prisma.CutConfigScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  teamId: 'teamId',
  ownerId: 'ownerId',
  lastEditorId: 'lastEditorId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  readOnly: 'readOnly',
  generic: 'generic',
  name: 'name',
  stockAssetUuid: 'stockAssetUuid',
  estimatePresetAssetUuid: 'estimatePresetAssetUuid',
  face: 'face',
  boreFinish: 'boreFinish',
  floorFinish: 'floorFinish',
  wallFinish: 'wallFinish',
  special: 'special',
  surface: 'surface',
  rough: 'rough',
  lightRough: 'lightRough',
  boreRough: 'boreRough',
  slot: 'slot',
  drill: 'drill',
  adaptiveRough: 'adaptiveRough',
  traditionalRough: 'traditionalRough',
  engrave: 'engrave',
  faceRough: 'faceRough',
  maxToolsPerSetup: 'maxToolsPerSetup',
  maxBullnoseEndmillRoughingRadius: 'maxBullnoseEndmillRoughingRadius',
  maxBullnoseEndmillFinishingRadius: 'maxBullnoseEndmillFinishingRadius',
  preferPreDrilling: 'preferPreDrilling',
  preferSpotDrilling: 'preferSpotDrilling',
  adaptiveRadialStockToLeave: 'adaptiveRadialStockToLeave',
  adaptiveAxialStockToLeave: 'adaptiveAxialStockToLeave',
  adaptiveTolerance: 'adaptiveTolerance',
  adaptiveSmoothing: 'adaptiveSmoothing',
  minorDeviationLimit: 'minorDeviationLimit',
  majorDeviationLimit: 'majorDeviationLimit'
};

exports.Prisma.CutConfigToolLibraryScalarFieldEnum = {
  cutConfigId: 'cutConfigId',
  toolLibraryId: 'toolLibraryId',
  createdAt: 'createdAt',
  priority: 'priority',
  type: 'type'
};

exports.Prisma.ProgramCutConfigScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  face: 'face',
  boreFinish: 'boreFinish',
  floorFinish: 'floorFinish',
  wallFinish: 'wallFinish',
  special: 'special',
  surface: 'surface',
  rough: 'rough',
  lightRough: 'lightRough',
  boreRough: 'boreRough',
  slot: 'slot',
  drill: 'drill',
  adaptiveRough: 'adaptiveRough',
  traditionalRough: 'traditionalRough',
  engrave: 'engrave',
  faceRough: 'faceRough'
};

exports.Prisma.ToolLibraryScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  teamId: 'teamId',
  ownerId: 'ownerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  readOnly: 'readOnly',
  generic: 'generic',
  shareKey: 'shareKey',
  name: 'name',
  description: 'description',
  presets: 'presets'
};

exports.Prisma.ToolLibraryToolScalarFieldEnum = {
  toolLibraryId: 'toolLibraryId',
  toolId: 'toolId',
  createdAt: 'createdAt',
  toolNumber: 'toolNumber',
  active: 'active'
};

exports.Prisma.ThreadScalarFieldEnum = {
  id: 'id',
  name: 'name',
  standard: 'standard',
  size: 'size',
  toleranceClass: 'toleranceClass',
  series: 'series',
  basicDiameter: 'basicDiameter',
  threadPitch: 'threadPitch',
  minMinorDiameter: 'minMinorDiameter',
  maxMinorDiameter: 'maxMinorDiameter',
  minMajorDiameter: 'minMajorDiameter'
};

exports.Prisma.HoleScalarFieldEnum = {
  id: 'id',
  partId: 'partId',
  threadId: 'threadId',
  featureIndex: 'featureIndex',
  diameter: 'diameter',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  centroid: 'centroid',
  normal: 'normal',
  threadPercentage: 'threadPercentage',
  type: 'type'
};

exports.Prisma.ProgramHoleScalarFieldEnum = {
  id: 'id',
  programId: 'programId',
  threadId: 'threadId',
  holeId: 'holeId',
  outOfSync: 'outOfSync',
  featureIndex: 'featureIndex',
  diameter: 'diameter',
  centroid: 'centroid',
  normal: 'normal',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  threadPercentage: 'threadPercentage',
  type: 'type'
};

exports.Prisma.ProgramToolScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  programId: 'programId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  toolNumber: 'toolNumber',
  toolId: 'toolId',
  active: 'active',
  priority: 'priority',
  configLibraryType: 'configLibraryType',
  userImported: 'userImported',
  toolLibraryId: 'toolLibraryId',
  toolData: 'toolData',
  name: 'name',
  typeId: 'typeId',
  unit: 'unit',
  diameter: 'diameter',
  stickout: 'stickout',
  fluteLength: 'fluteLength',
  fluteCount: 'fluteCount',
  tipAngle: 'tipAngle',
  maximumRpm: 'maximumRpm',
  cornerRadius: 'cornerRadius',
  toolMaterialId: 'toolMaterialId',
  threadPitch: 'threadPitch',
  clockwiseRotation: 'clockwiseRotation',
  nominalDiameter: 'nominalDiameter',
  threadLength: 'threadLength',
  shankDiameter: 'shankDiameter',
  leadAngle: 'leadAngle',
  partialThreadCount: 'partialThreadCount',
  bottomDiameter: 'bottomDiameter',
  role: 'role',
  shoulderDiameter: 'shoulderDiameter',
  threadProfileAngle: 'threadProfileAngle',
  numberOfTeeth: 'numberOfTeeth',
  neckLength: 'neckLength',
  sideMill: 'sideMill',
  toolHolderBottomDiameter: 'toolHolderBottomDiameter',
  vendor: 'vendor',
  productId: 'productId',
  link: 'link',
  guid: 'guid'
};

exports.Prisma.OperationFeatureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  type: 'type',
  label: 'label',
  featureIndex: 'featureIndex',
  machinable: 'machinable',
  selected: 'selected',
  properties: 'properties',
  suggestions: 'suggestions',
  operationId: 'operationId',
  roughingTime: 'roughingTime',
  finishingTime: 'finishingTime',
  machinedBy: 'machinedBy'
};

exports.Prisma.OperationFeatureToolScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  cutType: 'cutType',
  operationFeatureId: 'operationFeatureId',
  programToolId: 'programToolId',
  machiningTime: 'machiningTime',
  sort: 'sort',
  warning: 'warning',
  message: 'message'
};

exports.Prisma.OperationFeatureVendorToolScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  cutType: 'cutType',
  operationFeatureId: 'operationFeatureId',
  programToolId: 'programToolId',
  machiningTime: 'machiningTime',
  sort: 'sort',
  warning: 'warning',
  message: 'message'
};

exports.Prisma.ProgramEstimateScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  programId: 'programId',
  machiningRatePerMinute: 'machiningRatePerMinute',
  quantity: 'quantity',
  setupsMode: 'setupsMode',
  setupsFixed: 'setupsFixed',
  setupHourlyRate: 'setupHourlyRate',
  setupsHourlyDuration: 'setupsHourlyDuration',
  materialMode: 'materialMode',
  materialName: 'materialName',
  materialDensity: 'materialDensity',
  stockCostPerPound: 'stockCostPerPound',
  stockCostPerCubicInch: 'stockCostPerCubicInch',
  materialFixedPrice: 'materialFixedPrice',
  markup: 'markup',
  additionalItems: 'additionalItems',
  discountAmount: 'discountAmount'
};

exports.Prisma.AssetScalarFieldEnum = {
  id: 'id',
  uuid: 'uuid',
  parentUuid: 'parentUuid',
  type: 'type',
  teamId: 'teamId',
  ownerId: 'ownerId',
  isPublic: 'isPublic',
  validFrom: 'validFrom',
  validTo: 'validTo',
  name: 'name',
  dataVersion: 'dataVersion',
  data: 'data'
};

exports.Prisma.CostPerUnitScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  op: 'op',
  twoFeature: 'twoFeature',
  threeFeature: 'threeFeature',
  threadedHole: 'threadedHole',
  machiningTime: 'machiningTime',
  changeOver: 'changeOver',
  stock: 'stock',
  toolWear: 'toolWear',
  base: 'base'
};

exports.Prisma.EmailScalarFieldEnum = {
  id: 'id',
  messageId: 'messageId',
  userId: 'userId',
  createdAt: 'createdAt',
  name: 'name',
  email: 'email',
  subject: 'subject',
  textBody: 'textBody',
  htmlBody: 'htmlBody'
};

exports.Prisma.EmailAttachmentScalarFieldEnum = {
  id: 'id',
  emailId: 'emailId',
  partId: 'partId',
  index: 'index',
  name: 'name',
  contentType: 'contentType',
  contentLength: 'contentLength'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};
exports.Unit = exports.$Enums.Unit = {
  INCHES: 'INCHES',
  MILLIMETERS: 'MILLIMETERS'
};

exports.Control = exports.$Enums.Control = {
  TOOLPATH: 'TOOLPATH',
  FUSION: 'FUSION',
  ALIAS: 'ALIAS',
  INVENTOR: 'INVENTOR',
  SOLIDWORKS: 'SOLIDWORKS',
  TINKERCAD: 'TINKERCAD',
  POWERMILL: 'POWERMILL',
  ONSHAPE: 'ONSHAPE'
};

exports.Source = exports.$Enums.Source = {
  WEB_APP: 'WEB_APP',
  FUSION_QA: 'FUSION_QA',
  FUSION_CA: 'FUSION_CA',
  FUSION_DA: 'FUSION_DA',
  EMAIL: 'EMAIL',
  SAMPLE: 'SAMPLE'
};

exports.Color = exports.$Enums.Color = {
  BLUE: 'BLUE',
  GREEN: 'GREEN',
  TEAL: 'TEAL',
  YELLOW: 'YELLOW',
  ORANGE: 'ORANGE',
  RED: 'RED',
  GRAY: 'GRAY'
};

exports.ToolRole = exports.$Enums.ToolRole = {
  ROUGHING: 'ROUGHING',
  FINISHING: 'FINISHING',
  GENERAL_PURPOSE: 'GENERAL_PURPOSE',
  SPOTTING: 'SPOTTING',
  CENTER_DRILL: 'CENTER_DRILL'
};

exports.ConfigLibraryType = exports.$Enums.ConfigLibraryType = {
  USER: 'USER',
  VENDOR: 'VENDOR'
};

exports.HoleType = exports.$Enums.HoleType = {
  THROUGH: 'THROUGH',
  BLIND: 'BLIND'
};

exports.FeatureType = exports.$Enums.FeatureType = {
  UNKNOWN: 'UNKNOWN',
  THROUGH_HOLE: 'THROUGH_HOLE',
  BLIND_HOLE: 'BLIND_HOLE',
  THROUGH_POCKET: 'THROUGH_POCKET',
  POCKET: 'POCKET',
  THROUGH_OPEN_POCKET: 'THROUGH_OPEN_POCKET',
  OPEN_POCKET: 'OPEN_POCKET',
  PROFILE: 'PROFILE',
  BOSS: 'BOSS',
  FACE: 'FACE',
  COUNTERSINK: 'COUNTERSINK',
  CHAMFER: 'CHAMFER',
  FILLET: 'FILLET',
  FREE_FORM_SURFACE: 'FREE_FORM_SURFACE',
  SHOULDER: 'SHOULDER',
  CAVITY: 'CAVITY',
  MULTI_STEP_POCKET: 'MULTI_STEP_POCKET',
  CONTOUR_SURFACE: 'CONTOUR_SURFACE',
  FILLETED_POCKET: 'FILLETED_POCKET',
  THREAD: 'THREAD',
  PARTIAL_THROUGH_HOLE: 'PARTIAL_THROUGH_HOLE',
  PARTIAL_BLIND_HOLE: 'PARTIAL_BLIND_HOLE',
  FILLETED_OPEN_POCKET: 'FILLETED_OPEN_POCKET',
  FILLETED_BLIND_HOLE: 'FILLETED_BLIND_HOLE',
  WALL: 'WALL',
  SLANTED_FACE: 'SLANTED_FACE',
  INNER_FILLET: 'INNER_FILLET',
  OUTER_FILLET: 'OUTER_FILLET',
  SYNTHETIC_HOLE: 'SYNTHETIC_HOLE',
  PRE_ROUGH: 'PRE_ROUGH',
  FACING: 'FACING',
  FILLETED_BOSS: 'FILLETED_BOSS',
  TSLOT: 'TSLOT',
  SLIT: 'SLIT',
  DOVETAIL: 'DOVETAIL',
  FILLETED_TSLOT: 'FILLETED_TSLOT',
  BACK_COUNTERSINK: 'BACK_COUNTERSINK',
  BACK_CHAMFER: 'BACK_CHAMFER',
  UNDERCUT_WALL: 'UNDERCUT_WALL',
  U_SLOT: 'U_SLOT',
  FILLETED_DOVETAIL: 'FILLETED_DOVETAIL',
  TAPERED_THROUGH_HOLE: 'TAPERED_THROUGH_HOLE'
};

exports.CutType = exports.$Enums.CutType = {
  ROUGHING: 'ROUGHING',
  FINISHING: 'FINISHING'
};

exports.ProgramEstimateMode = exports.$Enums.ProgramEstimateMode = {
  FIXED: 'FIXED',
  CALCULATED: 'CALCULATED'
};

exports.Prisma.ModelName = {
  Backfills: 'Backfills',
  User: 'User',
  UserInviteToken: 'UserInviteToken',
  UserToken: 'UserToken',
  UserPasswordReset: 'UserPasswordReset',
  Team: 'Team',
  Subscription: 'Subscription',
  Project: 'Project',
  Tag: 'Tag',
  ProjectTag: 'ProjectTag',
  ProjectPart: 'ProjectPart',
  Part: 'Part',
  Body: 'Body',
  Program: 'Program',
  Operation: 'Operation',
  CandidateDirection: 'CandidateDirection',
  OperationAction: 'OperationAction',
  Workholding: 'Workholding',
  Tool: 'Tool',
  CutConfig: 'CutConfig',
  CutConfigToolLibrary: 'CutConfigToolLibrary',
  ProgramCutConfig: 'ProgramCutConfig',
  ToolLibrary: 'ToolLibrary',
  ToolLibraryTool: 'ToolLibraryTool',
  Thread: 'Thread',
  Hole: 'Hole',
  ProgramHole: 'ProgramHole',
  ProgramTool: 'ProgramTool',
  OperationFeature: 'OperationFeature',
  OperationFeatureTool: 'OperationFeatureTool',
  OperationFeatureVendorTool: 'OperationFeatureVendorTool',
  ProgramEstimate: 'ProgramEstimate',
  Asset: 'Asset',
  CostPerUnit: 'CostPerUnit',
  Email: 'Email',
  EmailAttachment: 'EmailAttachment'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
